<template>
  <LayoutFullScreen
    class="dbc-c-stage-fs"
    :style="`--bg-color: ${data.backgroundColor};`"
  >
    <div class="dbc-c-stage-fs__media">
      <video
        v-if="data.video"
        :src="
          isPreview()
            ? `${useRuntimeConfig().public.cms}${data.video.url}`
            : `/uploads/${data.video.name}`
        "
        :poster="`${useRuntimeConfig().public.cms}${data.poster.url}`"
        preload="auto"
        playsinline
        autoplay
        muted
        loop
      ></video>
      <div v-else>
        <div
          v-if="data.posterMobile"
          class="dbc-c-stage-fs__media min-tablet:hidden"
        >
          <UtilityImage
            :src="data.posterMobile.url"
            :sizes="'xs:640px sm:1024px'"
            :alt="data.posterMobileAlt"
            :copyright="data.copyright"
          />
        </div>
        <div
          class="dbc-c-stage-fs__media"
          :class="{ 'max-mobile:hidden': data.posterMobile }"
        >
          <UtilityImage
            :src="data.poster.url"
            :sizes="'xs:640px sm:1024px md:1280px lg:100vw xl:100vw xxl:100vw'"
            :alt="data.posterAlt"
            :copyright="data.copyright"
          />
        </div>
      </div>
    </div>

    <div
      v-if="data.headlineH1 || data.hideAppsBadge === false"
      class="dbc-c-stage-fs__content-wrapper"
    >
      <div class="dbc-c-stage-fs__content">
        <UtilityHeadline
          v-if="data.headlineH1"
          :class="`dbc-text-color-${data.headlineH1Color}`"
          :text="data.headlineH1"
          :level="1"
        />
        <div class="dbc-c-stage-fs__apps" v-if="data.hideAppsBadge === false">
          <UtilityAppsBadge
            v-for="app in computeAppsByOs"
            :key="app.id"
            :app="app"
          />
        </div>
      </div>
    </div>
  </LayoutFullScreen>
</template>
<script setup lang="ts">
const props = defineProps<{
  content: ContentStageFullScreen
}>()

const data = normalizeStageFullScreen(props.content)

const apps = inject('apps') as Ref<App[] | null>
const mobileOs = useMobileOs()

const computeAppsByOs = computed(() => {
  if (apps.value && mobileOs.value !== '') {
    return apps.value.filter((app) => app.os === mobileOs.value)
  }

  return apps.value
})
</script>
